import NavigationDesktop from '@frontend/features/navigation/NavigationDesktop'
import NavigationMobile from '@frontend/features/navigation/NavigationMobile'
import { NotificationBar } from '@frontend/features/notification-bar/NotificationBar'
import { isMobileDevice } from '@frontend/libs/utils'

function Header() {
  if (isMobileDevice) {
    return (
      <>
        <NotificationBar />
        <NavigationMobile />
      </>
    )
  }

  return (
    <>
      <NotificationBar />
      <NavigationDesktop />
    </>
  )
}

export default Header
